// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent, EditableComponentProps } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import { PointsWrapperProps } from './PointsWrapper.types';

const PointsWrapper = dynamic(() => import('./PointsWrapper').then(mod => mod.PointsWrapper));

export const PointsWrapperConfig = {
  emptyLabel: 'PointsWrapper',
  isEmpty: () => false,
  resourceType: `mi-aem-account/components/content/pointswrapper`,
};

type PointsWrapperEditableProps = EditableComponentProps & PointsWrapperProps;

export const PointsWrapperEditable = (props: PointsWrapperEditableProps) => {
  return (
    <EditableComponent config={PointsWrapperConfig} {...props}>
      <PointsWrapper {...props} />
    </EditableComponent>
  );
};
